<template>
  <div class="base-set-wrap">
    <div class="card-header">
      <span class="title-text"
        >基础设置
        <span class="error-tip" v-show="showTips">请补充完基础设置</span></span
      >
      <el-button class="add-plan" type="text" @click="showDrawerBox">
        <svg-icon iconClass="edit" className="edit-btn"></svg-icon
        >编辑</el-button
      >
    </div>
    <div class="set-form">
      <div class="form-item">
        <span class="item-lable">广告组名称：</span>
        <span class="item-value">{{ format_draft_adset }}</span>
      </div>
      <div class="form-item">
        <span class="item-lable">投放范围：</span>
        <span class="item-value">{{
          delivery_range === ""
            ? "-"
            : delivery_range === "default"
            ? "默认"
            : "快手联盟"
        }}</span>
      </div>
      <div class="form-item">
        <span class="item-lable">广告位置：</span>
        <span class="item-value"
          >{{
            scene_id === 1
              ? "优选广告位"
              : scene_id === 6
              ? "上下滑大屏广告"
              : scene_id === 10 || scene_id === 5
              ? "快手广告联盟"
              : "-"
          }}
        </span>
      </div>
    </div>
    <!-- 抽屉 -->
    <el-drawer
      title="基础设置"
      :visible.sync="showDrawer"
      size="674px"
      :show-close="false"
      class="drawer-wrap"
      @open="openDrawer"
      @closed="drawerClosed"
    >
      <edit-base-set
        ref="basesetRef"
        @closeDrawer="closeDrawer"
      ></edit-base-set>
    </el-drawer>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import EditBaseSet from "./editBaseSet.vue";
import { mapState } from "vuex";
import nameTransforUtil from "./common/nameTransforUtil.js";
export default {
  components: {
    SvgIcon,
    EditBaseSet,
  },
  data() {
    return {
      showDrawer: false,
      showTips: false,
    };
  },
  methods: {
    showDrawerBox() {
      if (!this.adCount) {
        this.$alert("请选择广告账号后再操作", "提示", {
          confirmButtonText: "确定",
        });
      } else {
        this.showDrawer = true;
      }
    },
    closeDrawer() {
      this.showDrawer = false;
    },
    openDrawer() {
      //弹框打开查询表单数据
      this.$nextTick(() => {
        this.$refs.basesetRef.initFormData();
      });
    },
    drawerClosed() {
      //保存数据到store
      this.$refs.basesetRef.saveDataInStore();
      //数据格式校验，显示校验标识
      this.$refs.basesetRef
        .checkData()
        .then(() => {})
        .catch(() => {});
    },
    controlTips(data) {
      this.showTips = data;
    },
    async checkData() {
      if (this.$refs.basesetRef) {
        return await this.$refs.basesetRef
          .checkData()
          .then(() => {
            console.log("抽屉检查通过");
            this.controlTips(false);
            return Promise.resolve();
          })
          .catch(() => {
            console.log("抽屉检查没通过");
            this.controlTips(true);
            return Promise.reject();
          });
      } else {
        //存在广告计划名称但是组件没有挂载说明选择了模板
        if (this.format_draft_adset !== "-") {
          this.controlTips(false);
          return Promise.resolve();
        } else {
          this.controlTips(true);
          return Promise.reject();
        }
      }
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionKuaishou.adCount,
      draft_adset: (state) => state.PromotionKuaishou.draft_adset,
    }),
    format_draft_adset() {
      return this.draft_adset.name_rule
        ? nameTransforUtil.apiDatatoShow(this.draft_adset.name_rule)
        : "-";
    },
    delivery_range() {
      return this.draft_adset.delivery_placement.delivery_range;
    },
    scene_id() {
      let data = this.draft_adset.delivery_placement.scene_id;
      return data ? data[0] : null;
    },
  },
};
</script>

<style lang="less" scoped>
.base-set-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    display: flex;
    justify-content: space-between;
    .title-text {
      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      font-weight: bold;
      .error-tip {
        font-size: 12px;
        color: #f56c6c;
        font-weight: normal;
        margin-left: 6px;
      }
    }
    .edit-btn {
      margin-right: 6px;
      font-size: 14px;
    }
  }
  .set-form {
    margin-top: 18px;
    .form-item {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 38px;
      .item-lable {
        display: inline-block;
        width: 100px;
      }
    }
  }
  .drawer-wrap {
    /deep/.el-drawer__header {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.95);
      font-weight: bold;
      margin-bottom: 22px;
    }
  }
}
</style>